<span
    class="custom-truncate-text"
    [ngStyle]="{ maxWidth: maxWidth, color: textColor }"
    pTooltip="{{ text }}"
    tooltipPosition="bottom">
    {{ text }}
</span>
